// import { Row, Col, Button, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from "react-router";import "../crmComponents/Contacts.css";
import { useState, useEffect, useCallback } from "react";

//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import { deleteContact, fetchContactDetails, fetchContactsList, fetchProspectsList } from "../../redux/actions/crmActions";
import Loading from "../assetLibComponents/Loading";


const Accounts = () => {
  return (
    <div>Accounts</div>
  )
}

export default Accounts